module.exports = __webpack_public_path__ + "img/HydroNext_80X30.e70aea82.png";